const codeModules = {
	CVENTA: 'sales',
	VENTA: 'sales',
	BANCO: 'treasury',
	CAJA: 'treasury',
	CTAXCOB: 'accountsReceivable',
	CTAXPAG: 'accountsPayable',
	CTAXCOBFAC: 'accountsReceivable',
	CTAXPAGFAC: 'accountsPayable',
	COMPRA: 'purchases',
};
export default codeModules;



// WEBPACK FOOTER //
// ./src/shared/codeModules.js